import React from "react";
import { useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";
import logoMainPrimary from "../../assets/new-revamp/header/poolMoney.png";
import logoMainWhite from "../../assets/new-revamp/header/poolMoneyWhite.png";

const Footer = React.memo((props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <footer
      className={`${props?.dark ? "" : "bg-primary border-t border-light"} text-white py-10 anek-latin-300 snap-end`}
      style={props?.dark ? { background: "#0f0a1a" } : {}}
    >
      <div className="max-w-7xl mx-auto px-8 md:px-12">
        <div className="flex flex-wrap justify-between gap-12 md:flex-nowrap">
          {/* Logo Section */}
          <div className="flex flex-col items-start ">
            <div className={`ml-[-16px] md:ml-[-20px] text-6xl font-bold object-cover ${props.dark ? "text-white" : "text-primary"}`}>
              <a href="/">
                <img src={props?.dark ? logoMainWhite : logoMainPrimary} alt="Logo" className="w-[45%] md:w-[27%]" />
              </a>
            </div>
            <span className="font-bold">
              Pardna Technologies Private Limited
            </span>
          </div>

          {/* Company and Product Links Section */}
          <div className="flex gap-8 md:w-[20%]">
            <div className="space-y-4">
              <h3 className="text-xl font-semibold">{t("Company")}</h3>
              <ul className={`space-y-2 ${props.dark ? "text-gray-400" : ""}`}>
                <li className="about-us">
                  <a className={`about-us ${props.dark ? "hover:text-purple-300 transition-colors" : ""}`} href="/aboutUs/">
                    {t("About us")}
                  </a>
                </li>
                <li className="meet-the-team">
                  <a className={`meet-the-team ${props.dark ? "hover:text-purple-300 transition-colors" : ""}`} href="/meetTheTeam/">
                    {t("Meet The Team")}
                  </a>
                </li>
                <li className="privacy-policy">
                  <a className={`privacy-policy ${props.dark ? "hover:text-purple-300 transition-colors" : ""}`} href="/privacyPolicy/">
                    {t("Privacy Policy")}
                  </a>
                </li>
                <li className="terms-and-conditions">
                  <a
                    className={`terms-and-conditions ${props.dark ? "hover:text-purple-300 transition-colors" : ""}`}
                    href="/termsAndConditions/"
                  >
                    {t("Terms And Conditions")}
                  </a>
                </li>
                <li className="refund-cancellation">
                  <a
                    href="/refundAndCancellation/"
                    className={`refund-cancellation ${props.dark ? "hover:text-purple-300 transition-colors" : ""}`}
                  >
                    {t("Refund And Cancellation")}
                  </a>
                </li>
                <li className="careers">
                  <a className={`careers ${props.dark ? "hover:text-purple-300 transition-colors" : ""}`} href="/careers/">
                    {t("Careers")}
                  </a>
                </li>
                <li className="contact">
                  <a className={`contact ${props.dark ? "hover:text-purple-300 transition-colors" : ""}`} href="/contact/">
                    {t("Contact")}
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Support Section */}
          <div className="space-y-4">
            <h3 className="text-xl font-semibold">{t("Support")}</h3>
            <p className={`${props.dark ? "text-gray-400" : ""}`}>
              {t("Get Answers and Assistance Right Where You Need It")}
            </p>
            <a href="" className="flex items-center mt-4">
              <div
                className="mr-2 rounded-full p-3"
                style={props?.dark ? { background: "rgba(139,92,246,0.15)", color: "#a78bfa" } : { background: "#fff", color: "#1B1B1B" }}
              >
                <svg
                  width={22}
                  height={18}
                  fill="none"
                  viewBox="0 0 22 18"
                  className=""
                >
                  <path
                    stroke={props?.dark ? "#a78bfa" : "#1B1B1B"}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeOpacity={props?.dark ? "1" : ".6"}
                    strokeWidth={2}
                    d="M21 3c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2m20 0v12c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3m20 0-10 7L1 3"
                  />
                </svg>
              </div>
              admin@poolmoney.in
            </a>
          </div>
        </div>

        {/* Copyright & Contact Info */}
        <p className={`border-t pt-8 text-center text-sm mt-8 ${props.dark ? "text-gray-400 border-purple-900/40" : "border-gray-400"}`}>
          &copy; PoolMoney 2021-2026 All rights reserved
        </p>
      </div>
    </footer>
  );
});

Footer.displayName = "Footer";
export default Footer;
